import {
  GET_QUESTIONS,
  GET_QUESTIONS_LIST,
  GET_QUESTIONS_MINIMAL,
  GET_QUESTION,
  ADD_QUESTION,
  DELETE_QUESTION,
  UPDATE_QUESTION,
  QUESTIONS_LOADING,
  QUESTION_LOADING,
  CLEAR_CURRENT_QUESTION,
  SET_QUESTIONS_PAGE
} from '../actions/types';

const initialState = {
  questions: [],              // Lightweight list for table
  minimalQuestions: [],       // Minimal list for filters
  currentQuestion: null,      // Full question data for view/edit pages
  loading: false,             // For list loading
  questionLoading: false,     // For single question loading
  currentPage: 1,             // Current page number
  totalPages: 0,              // Total number of pages
  totalQuestions: 0,          // Total number of questions
  hasNextPage: false,         // Whether there's a next page
  hasPrevPage: false          // Whether there's a previous page
};

export default function questionReducer(state = initialState, action) {
  switch (action.type) {
    case GET_QUESTIONS_LIST:
      return {
        ...state,
        questions: action.payload.questions || action.payload,
        currentPage: action.payload.currentPage || 1,
        totalPages: action.payload.totalPages || 0,
        totalQuestions: action.payload.totalQuestions || 0,
        hasNextPage: action.payload.hasNextPage || false,
        hasPrevPage: action.payload.hasPrevPage || false,
        loading: false
      };

    case GET_QUESTIONS_MINIMAL:
      return {
        ...state,
        minimalQuestions: action.payload,
        loading: false
      };

    case GET_QUESTION:
      return {
        ...state,
        currentQuestion: action.payload,
        questionLoading: false
      };

    case QUESTION_LOADING:
      return { ...state, questionLoading: true };

    case CLEAR_CURRENT_QUESTION:
      return { ...state, currentQuestion: null, questionLoading: false };

    case ADD_QUESTION:
      return {
        ...state,
        // Add lightweight version to list
        questions: [
          {
            _id: action.payload._id,
            text: action.payload.text,
            program: action.payload.program,
            tags: action.payload.tags,
            options: action.payload.options,
            createdAt: action.payload.createdAt,
            updatedAt: action.payload.updatedAt
          },
          ...state.questions
        ],
        currentQuestion: action.payload,
        loading: false
      };

    case UPDATE_QUESTION:
      return {
        ...state,
        // Update in list
        questions: state.questions.map(question =>
          question._id === action.payload._id
            ? {
                _id: action.payload._id,
                text: action.payload.text,
                program: action.payload.program,
                tags: action.payload.tags,
                options: action.payload.options,
                createdAt: action.payload.createdAt,
                updatedAt: action.payload.updatedAt
              }
            : question
        ),
        currentQuestion: action.payload,
        loading: false
      };

    case DELETE_QUESTION:
      return {
        ...state,
        questions: state.questions.filter(question => question._id !== action.payload),
        currentQuestion: null,
        loading: false
      };

    case QUESTIONS_LOADING:
      return {
        ...state,
        loading: true
      };

    case GET_QUESTIONS: // Keep for backward compatibility
      return {
        ...state,
        questions: action.payload,
        loading: false
      };

    case SET_QUESTIONS_PAGE:
      return { ...state, currentPage: action.payload };

    default:
      return state;
  }
}
